import { InvoiceAddressStructured } from '@shared/models/invoice';

/** Zero-width and format characters that pdfMake/Roboto cannot render (show as □ in PDFs). */
const INVISIBLE_UNICODE_RE = /[\u200B-\u200F\u2060\uFEFF\u00AD]/g;

/**
 * Removes invisible Unicode from a single address field (Tolgee/copy-paste artefacts).
 */
export function sanitizeAddressField(value: string | null | undefined): string {
    if (value == null) {
        return '';
    }
    return String(value).replace(INVISIBLE_UNICODE_RE, '').trim();
}

/**
 * Builds the multi-line address string used for Barbeleg PDFs from structured form fields.
 */
export function buildStructuredAddressString(structured: InvoiceAddressStructured | null | undefined): string {
    if (!structured) {
        return '';
    }

    const salutation = sanitizeAddressField(structured.salutation);
    const title = sanitizeAddressField(structured.title);
    const firstName = sanitizeAddressField(structured.firstName);
    const lastName = sanitizeAddressField(structured.lastName);
    const street = sanitizeAddressField(structured.street);
    const zip = sanitizeAddressField(structured.zip);
    const city = sanitizeAddressField(structured.city);
    const country = sanitizeAddressField(structured.country);

    const hasAnyField = lastName || firstName || street || city;
    if (!hasAnyField) {
        return '';
    }

    const parts: string[] = [];
    const nameParts = [salutation, title, firstName, lastName].filter(Boolean);
    if (nameParts.length) {
        parts.push(nameParts.join(' '));
    }
    if (street) {
        parts.push(street);
    }
    const cityLine = [zip, city].filter(Boolean).join(' ');
    if (cityLine) {
        parts.push(cityLine);
    }
    if (country) {
        parts.push(country);
    }

    return parts.join('\n');
}
